import React from "react";
import i18next from "i18next";
import { TABLE_BODY_CELL_LINK } from "../../classConstants";
import { getClassName } from "../../helpers";
import { defineProperties } from "../../translationService";
import createEntityScreen from "../layout/connectedEntityScreen";
export var billScreenColumns = [
    defineProperties({ key: "billid", }, { label: 'user_entity.bills.bill_id', }),
    defineProperties({ key: "dueamount", align: "right" }, { label: 'user_entity.bills.due_amount', }),
    defineProperties({ key: "price", align: "right" }, { label: 'user_entity.bills.price', }),
    defineProperties({ key: "downloadlink", isLink: true }, { label: 'user_entity.bills.download', }),
];
export var UserBillsScreen = createEntityScreen({
    entityName: 'bills',
    columnHeaders: billScreenColumns,
    columnConfiguration: "userBillsColumns",
    renderCell: function (record, column, wrapFunction) {
        switch (column) {
            case "downloadlink": {
                return !record[column] ? null : React.createElement("a", { download: true, className: getClassName(TABLE_BODY_CELL_LINK, "ws-booking-download-link"), href: record[column] }, i18next.t("user_entity.bills.download_link"));
            }
        }
        return wrapFunction(record[column]);
    },
});
